/* unplugin-vue-components disabled */import { render } from "./populated-cart.vue?vue&type=template&id=6ef39948"
import script from "./populated-cart.vue?vue&type=script&lang=js"
export * from "./populated-cart.vue?vue&type=script&lang=js"

import "./populated-cart.vue?vue&type=style&index=0&id=6ef39948&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__